import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'react-emotion';
import i18next from 'i18next';

import { Label } from '~/modules/coreUI/components/basic/Labels';
import Icon from '~/modules/coreUI/components/basic/Icon';
import { Row, Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import BasicLink from '~/modules/ecommerceCoreUI/components/basic/Link';
import urlFor from '~/modules/ecommerceCore/utils/UrlConcatination';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';
import { OfferContainer, LabelItem } from '~/modules/ecommerceOrder/containers/inviteFriend/LabelWithAction';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';

const OfferName = withMedia(styled(Label)`
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: ${props => 6.5 * props.theme.new.spacer}px;
  ${props => props.media.minTablet && css`
     width: ${12 * props.theme.new.spacer}px;
  `}
  ${props => props.media.minDesktop && css`
     width: ${20 * props.theme.new.spacer}px;
  `}
`);

const ProductOffers = ({ offers, media }) => (
  <Column maxWidth={50} leftAligned spaceBetween={1}>
    {offers.map(offer => (
      <Row fullWidth={media.maxMobile} key={offer.ref_id}>
        <LabelItem spaceBetween={0.5}>
          <Icon primary className="el-icon el-icon-offer-label-tag" />
          <Label primary sm>
            {i18next.t('ecommerceCoreUI:Product.offerLabel')}
          </Label>
        </LabelItem>
        <OfferContainer spaceBetweenJustified fullWidth spaceBetween={1.5}>
          <OfferName semiBold sm>
            {offer.name}
          </OfferName>
          <Label>
            <BasicLink targeturl={urlFor('getProductDetailsLink', [offer.slug, offer.vendor_variants_count, offer.min_variant?.vendor])} secondary>
              <Row spaceBetween={0.5}>
                <Label semiBold sm secondary>{i18next.t('ecommerceCoreUI:Product.viewOfferLink')}</Label>
                <Icon className="el-icon el-icon-right" />
              </Row>
            </BasicLink>
          </Label>
        </OfferContainer>
      </Row>
    ))}
    <Spacer />
  </Column>
);

ProductOffers.propTypes = {
  offers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  media: PropTypes.shape({
    maxMobile: PropTypes.bool,
  }).isRequired,
};

export default withMedia(ProductOffers);
